import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'; // Importando Material Design Icons

Vue.use(Vuetify)

export default new Vuetify()